import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MapPin, ChevronRight } from "lucide-react";
import api from "../../lib/api";
import { CandidateTabs } from "../../components/candidate/CandidateTabs";

const STATUS_STYLE = {
  pending: "bg-amber-100 text-amber-700",
  reviewed: "bg-blue-100 text-blue-700",
  accepted: "bg-housing/15 text-housing",
  rejected: "bg-red-100 text-red-600",
};

export default function Applications() {
  const { t, i18n } = useTranslation();
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/candidate/applications").then(({ data }) => setApps(data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const fmt = (d) => (d ? new Date(d).toLocaleDateString(i18n.language) : "");

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-heading text-3xl font-bold text-stone-text mb-6">{t("candidate.applications.title")}</h1>
      <CandidateTabs />

      {loading ? (
        <div className="py-16 text-center text-stone-muted">{t("jobs.loading")}</div>
      ) : apps.length === 0 ? (
        <div className="py-16 text-center text-stone-muted" data-testid="applications-empty">{t("candidate.applications.empty")}</div>
      ) : (
        <div className="space-y-3" data-testid="applications-list">
          {apps.map((app) => (
            <Link
              key={app.id}
              to={`/jobs/${app.job_id}`}
              data-testid="application-item"
              className="flex items-center justify-between gap-4 bg-white rounded-2xl border border-stone-border shadow-sm p-4 hover:shadow-md transition-all"
            >
              <div className="min-w-0">
                <h3 className="font-heading font-semibold text-stone-text truncate">{app.job?.title || "—"}</h3>
                <p className="text-sm text-stone-sub truncate">{app.job?.restaurant?.name}</p>
                <div className="flex items-center gap-1 text-xs text-stone-muted mt-1">
                  <MapPin className="w-3.5 h-3.5" /> {app.job?.city}{app.job?.state ? `, ${app.job.state}` : ""}
                  <span className="mx-1">·</span> {t("candidate.applications.appliedOn")} {fmt(app.created_at)}
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${STATUS_STYLE[app.status] || "bg-stone-bg text-stone-sub"}`}>
                  {t(`candidate.applications.status.${app.status}`, app.status)}
                </span>
                <ChevronRight className="w-5 h-5 text-stone-muted" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
